/**
 * 克隆/试听音频路径转公网 URL（与 AudioPlay.vue、上传返回格式一致）
 */
export function toPublicAudioUrl(filepath) {
  if (!filepath) return ''
  const s = String(filepath).trim()
  if (!s) return ''
  if (/^https?:\/\//i.test(s)) return s
  if (s.indexOf('record') !== -1) {
    const tail = s.split('record')[1]
    if (tail) return `${webConfig.api.audio}${tail}`
  }
  if (s.startsWith('/mnt/upload/')) {
    return `${webConfig.api.audio}${s.replace(/^\/mnt\/upload/, '/scene')}`
  }
  if (s.startsWith('/upload/')) {
    return `${webConfig.api.audio}${s}`
  }
  return s
}
